import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TRUE, FALSE, COLOR_EDIT, UNSET } from "../../../constants/general-constants";
import { useHistory } from 'react-router-dom';
import { functions } from "../../../constants/common-functions";
import HomeBox from "../components/HomeBox";
import { OMNISCAN_CORPORATE_GREEN_RGB } from "../../../constants/colors";
import {DEFAULT_BLUE_GRADIENT} from "../../../constants/styles";

export default function HomeBoxDocuments({ displayBlur }) {

    const history = useHistory();

    const [resourceTypes, setResourceTypes] = useState([]);

    /* ---------------------------------------------
       Dummy document resource types (UI seed)
    --------------------------------------------- */
    const dummyDocumentTypes = [
        { resourceTypeId: UNSET, resourceTypeName: "O & M Manuals", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "DWGs & Drawings", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "BIM Models", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "Asset Registers", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "Policies", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "Compliance", numberResources: 0 },
        { resourceTypeId: UNSET, resourceTypeName: "Reports", numberResources: 0 }
    ];

    useEffect(() => {
        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/home/resources/counts",
            function (data) {
                if (!data || data.length === 0) {
                    //setResourceTypes(dummyDocumentTypes);
                } else {
                    setResourceTypes(data);
                }
            },
            null
        );
    }, []);

    const thisContainer = {
        display: 'flex',
        width: "100%",
        minHeight: "200px",
        padding: "5px",
        flexWrap: "wrap"
    };

    const fileBox = {
        display: "flex",
        background: "linear-gradient(180deg, #ffffff 0%, #f3f4f6 100%)",
		//background:'rgba(255, 255, 255, 0.5)',
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        borderRadius: "8px",
        height: "40px",
        margin: "5px",
        alignItems: 'center',
        width: 'calc(50% - 12px)',
        cursor: "pointer"
    };

    const fileBoxTitle = {
        display: 'flex',
        fontSize: "13px",
        marginLeft: "5px",
        color: "rgba(0,0,0,0.65)",
        width: "calc(100% - 60px)"
    };

    const fileBoxCount = {
        display: 'flex',
        fontSize: "12px",
        color: "white",
        minWidth: "40px",
        maxWidth: "40px",
        height: "28px",
        borderRadius: "3px",
        marginRight: "8px",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        background: `linear-gradient(
            180deg,
            rgba(${OMNISCAN_CORPORATE_GREEN_RGB}, 0.88) 0%,
            rgba(${OMNISCAN_CORPORATE_GREEN_RGB}, 1) 100%
        )`,
        border: "1px solid rgba(255,255,255,0.12)"
    };

    const fileBoxIcon = {
        display: "flex",
        marginLeft: "10px",
        height: "18px",
        width: "18px",
        color: "black"
    };

    const handleClick = (id) => {
        history.push("/resources/" + id);
    };

    const resourceTypeDisplay = resourceTypes.map((item, index) =>
        <div
            key={index}
            style={fileBox}
            onClick={() => handleClick(item.resourceTypeId)}
        >
            <FontAwesomeIcon icon="file" style={fileBoxIcon} />
            <div style={fileBoxTitle}>
                {item.resourceTypeName}
            </div>
            <div style={fileBoxCount}>
                {item.numberResources}
            </div>
        </div>
    );

    const clickFunction = () => {
        handleClick(UNSET);
    };

    return (
        <HomeBox
            isLive={true}
            title="Docs"
            color={COLOR_EDIT}
            colorRgb={OMNISCAN_CORPORATE_GREEN_RGB}
            clickFunction={clickFunction}
            icon="file"
            displayBlur={displayBlur}
			delay={480}
        >
            <div style={thisContainer}>
                {resourceTypeDisplay}

                {/* Search All */}
                <div
                    style={{
                        ...fileBox,
                        background: DEFAULT_BLUE_GRADIENT,
                        border: "1px solid rgba(255,255,255,0.08)",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.25)"
                    }}
                    onMouseOver={e => {
                        e.currentTarget.style.filter = "brightness(1.10)";
                        e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseOut={e => {
                        e.currentTarget.style.filter = "brightness(1)";
                        e.currentTarget.style.transform = "none";
                    }}
                    onClick={() => handleClick(UNSET)}
                >
                    <FontAwesomeIcon icon="search" style={{ ...fileBoxIcon, color: "white" }} />
                    <div
                        style={{
                            ...fileBoxTitle,
                            color: "white",
                            paddingLeft: "5px",
                            fontWeight: 500,
                            letterSpacing: "0.25px"
                        }}
                    >
                        Search All
                    </div>
                </div>
            </div>
        </HomeBox>
    );
}